import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import '../../queries/cancel-appointment-by-token.js';
import '../../queries/cancel-appointment-by-id.js';
import '../../queries/get-appointment-by-id.js';
import '../../queries/get-appointment-by-token.js';
import '../../queries/get-store-by-code.js';
import { GET_STORE_BY_ID } from '../../queries/get-store-by-id.js';
import { fromStoreByIdQueryToStore } from './adapters/fromStoreByIdQueryToStore.js';

const useStoreById = (variables)=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_STORE_BY_ID, {
        variables,
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        }
    });
    const data = React.useMemo(()=>{
        var ref;
        return ((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.store) ? fromStoreByIdQueryToStore(queryState.data.store) : null;
    }, [
        queryState
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            }), 
        ]
    , [
        data,
        queryState,
        query
    ]);
};

export { useStoreById as default };
//# sourceMappingURL=use-store-by-id.js.map
